import React from 'react'
import { ClientStudentListContainer } from '@/components/containers/client-student-list'

export const ClientStudentListPage: React.FC = () => {
  return <ClientStudentListContainer />
}
